module.exports = __webpack_public_path__ + "static/img/7.f49f95e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empresas/7.png
// module id = geFC
// module chunks = 0